import { Navigate, Outlet, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth"
import { useEffect } from "react";
import {APP_TOKEN} from '../constants/app-token';
import { decryptData } from "../utils/utilities";

const RequireAuth = () => {
    const {auth} = useAuth();

    return ( 
        auth?.valid
        ? <Outlet />
        : <Navigate to="/UnauthorizedAccess" />
    )

}

export default RequireAuth